import React, { createContext, useContext } from 'react';
import {
  UseProfilePageUser,
  useProfilePageUser,
} from 'hooks/useProfilePageUser';

/**
 * Shares one `useProfilePageUser` REST read across the fullscreen profile
 * sidebar. Both the profile details card (manager block) and the permissions
 * card need the org-user payload; without this they would each fire the same
 * `/organizations/:org/users/:user` request.
 *
 * Consumers outside a provider (e.g. the sider/non-fullscreen view, which does
 * not need this data) receive an inert default.
 */
const DEFAULT: UseProfilePageUser = {
  user: null,
  manager: null,
  managedLocationNames: [],
  loading: false,
  error: null,
};

const ProfilePageUserContext = createContext<UseProfilePageUser>(DEFAULT);

type ProfilePageUserProviderProps = {
  userId: string;
  children: React.ReactNode;
};

export const ProfilePageUserProvider = ({
  userId,
  children,
}: ProfilePageUserProviderProps): JSX.Element => {
  const value = useProfilePageUser(userId);
  return (
    <ProfilePageUserContext.Provider value={value}>
      {children}
    </ProfilePageUserContext.Provider>
  );
};

export const useProfilePageUserContext = (): UseProfilePageUser =>
  useContext(ProfilePageUserContext);
